/* eslint-disable import/prefer-default-export */
import { useStoreActions, useReducerData } from 'store/hooks';
// ACTIONS
import * as documentManagementActions from 'views/DocumentManagement/redux/actions';

export const useIndexData = () => {
  const allDocuments = useReducerData('documentManagement', 'productAllFiles.data', {});
  const archivedDocuments = useReducerData('documentManagement', 'productArchivedFiles.data', {});
  return {
    allDocuments,
    archivedDocuments,
  };
};

export const useActions = () => {
  return useStoreActions({
    ...documentManagementActions,
  });
};
